import React from 'react';
import { ReactComponent as ChevronDown } from 'assets/img/chevron-down.svg';
import { ReactComponent as ChevronRight } from 'assets/img/chevron-right.svg';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export default function Button({ label, items, variant }) {
  return (
    <div
      data-component-name='ButtonSelect'
      className={`flex items-center justify-center text-base w-full ${
        variant === 'light'
          ? 'border border-blue-100 rounded-md bg-white-400 text-blue-300'
          : 'text-white-400 bg-button-gradient rounded-lg'
      }`}
    >
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button
            type='button'
            // onClick={() => action()}
            className={`flex flex-1 items-center justify-between gap-2.5 whitespace-nowrap h-11 px-4 outline-none `}
          >
            {label}
            <div
              className={`-ml-0.5  ${
                variant === 'light' ? 'text-blue-100' : 'text-white-400'
              }`}
            >
              <ChevronDown />
            </div>
          </button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Content className='z-10'>
          {items && (
            <div className='w-full mt-2 overflow-hidden text-blue-500 border border-blue-100 border-solid rounded-md shadow-md'>
              {items.map((item, i) => {
                return (
                  <DropdownMenu.Item asChild key={i}>
                    <button
                      type='button'
                      onClick={() => item.action()}
                      className='px-2.5 h-10 flex w-full flex-1 justify-between group items-center outline-none bg-white-400 hover:bg-blue-50 min-w-[167px]'
                    >
                      {item.label}

                      <div className='opacity-0 group-hover:opacity-100'>
                        <ChevronRight />
                      </div>
                    </button>
                  </DropdownMenu.Item>
                );
              })}
            </div>
          )}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
